// extracted by mini-css-extract-plugin
module.exports = {"root":"_3Ipid","position-fixed":"_1XxOx","positionFixed":"_1XxOx","clickable":"CBL4Z","lightbox-layer":"_2DihO","lightboxLayer":"_2DihO"};